/* ═══════════════════════════════════════════════════════
   NEWWELL THEME — Global JavaScript
   HAYTEK AI Creative Studio
═══════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── GSAP ScrollTrigger Reveal ── */
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
    gsap.utils.toArray('.reveal').forEach(el => {
      gsap.fromTo(el,
        { opacity: 0, y: 28 },
        {
          opacity: 1, y: 0, duration: .8,
          ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 88%', once: true }
        }
      );
    });
  }

  /* ── Header Scroll Effect ── */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const current = window.scrollY;
      if (current > 80) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      if (current > lastScroll && current > 200) {
        header.classList.add('hidden');
      } else {
        header.classList.remove('hidden');
      }
      lastScroll = current;
    }, { passive: true });
  }

  /* ── Announcement Bar Scroll ── */
  const bar = document.querySelector('.announcement-track');
  if (bar) {
    const clone = bar.cloneNode(true);
    bar.parentElement.appendChild(clone);
  }

  /* ── Countdown Timer ── */
  document.querySelectorAll('[data-countdown]').forEach(el => {
    const endDate = new Date(el.dataset.countdown);
    const update = () => {
      const diff = endDate - Date.now();
      if (diff <= 0) { el.textContent = 'ABGELAUFEN'; return; }
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      el.querySelector('[data-h]').textContent = String(h).padStart(2, '0');
      el.querySelector('[data-m]').textContent = String(m).padStart(2, '0');
      el.querySelector('[data-s]').textContent = String(s).padStart(2, '0');
    };
    update();
    setInterval(update, 1000);
  });

  /* ── FAQ Accordion ── */
  document.querySelectorAll('.faq-item').forEach(item => {
    const trigger = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    if (!trigger || !answer) return;
    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(open => {
        open.classList.remove('open');
        open.querySelector('.faq-answer').style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* ── Social Proof Toast ── */
  const toastContainer = document.getElementById('social-proof-toast');
  if (toastContainer) {
    const toasts = JSON.parse(toastContainer.dataset.toasts || '[]');
    if (toasts.length === 0) return;
    let index = 0;
    const show = () => {
      const t = toasts[index % toasts.length];
      index++;
      const el = document.createElement('div');
      el.className = 'sp-toast';
      el.innerHTML = `
        <div class="sp-toast__img">🛍️</div>
        <div class="sp-toast__body">
          <strong>${t.name}</strong> aus ${t.location}<br>
          <span>kauft gerade: ${t.product}</span>
        </div>
        <span class="sp-toast__time">${t.time_ago}</span>
        <button class="sp-toast__close" aria-label="Schließen">✕</button>`;
      toastContainer.appendChild(el);
      requestAnimationFrame(() => el.classList.add('visible'));
      const dur = parseInt(toastContainer.dataset.duration || '4000');
      const timer = setTimeout(() => dismiss(el), dur);
      el.querySelector('.sp-toast__close').addEventListener('click', () => {
        clearTimeout(timer); dismiss(el);
      });
    };
    const dismiss = el => {
      el.classList.remove('visible');
      setTimeout(() => el.remove(), 400);
    };
    const interval = parseInt(toastContainer.dataset.interval || '6000');
    setTimeout(() => { show(); setInterval(show, interval); }, 3000);
  }

  /* ── Sticky ATC Visibility ── */
  const stickyAtc = document.getElementById('sticky-atc');
  if (stickyAtc) {
    const threshold = parseInt(stickyAtc.dataset.threshold || '600');
    window.addEventListener('scroll', () => {
      if (window.scrollY > threshold) {
        stickyAtc.classList.add('visible');
      } else {
        stickyAtc.classList.remove('visible');
      }
    }, { passive: true });
  }

  /* ── Mobile Nav Toggle ── */
  const navToggle = document.querySelector('.nav-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

});
